import { Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useContext } from 'react';
import { isNil } from 'lodash-es';

import { FAIcon } from '../../components/adapters/fontAwesomeAdapters';
import InlineDialog from '../../components/dialogs/InlineDialog';
import { FiltersAndSortContext } from '../../components/data/FiltersAndSortProvider';
import { useMonitorNoDataStyles } from './MonitorNoData.styles';

export default function MonitorNoData() {
  const { styles } = useMonitorNoDataStyles();
  const { filters } = useContext(FiltersAndSortContext);
  const hasFilter = Object.values(filters?.values).some(
    filter => !isNil(filter)
  );

  return (
    <InlineDialog
      className={styles.monitorNoData}
      icon={<FAIcon icon="exclamation-triangle" />}
    >
      <Typography.Title level={2}>
        <FormattedMessage id="titles.attention" />
      </Typography.Title>
      <Typography.Paragraph className="nl-as-newline">
        <FormattedMessage
          id={hasFilter ? 'filterResult.empty' : 'monitor.empty'}
        />
      </Typography.Paragraph>
    </InlineDialog>
  );
}
